/**
 * The default penalty for a pathway in milliseconds.
 *
 * @group Content Steering
 *
 * @beta
 */
export const DEFAULT_PATHWAY_PENALTY = 300000;
//# sourceMappingURL=DEFAULT_PATHWAY_PENALTY.js.map